var styles = {"differentialPrice":"ep-pricing-module-differential-price-ZGlmZ"};

export { styles as default };
